<template>
    <section class="attachment-viewer-modal esesja-modal" ref="modal" tabindex="0" @keyup="keyPressed">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__body">
                <section class="attachment-viewer--header" ref="headerSection">
                    <section class="attachment-viewer--controls" v-if="viewerState.isPdf && viewerState.isReady"
                        ref="controlsSection">
                        <section class="attachment-viewer--controls__scale">
                            <button class="attachment-viewer--control-button attachment-viewer--control-button--small"
                                @click="scaleDownIframe"
                                :disabled="viewerState.isBusy || viewerState.scale <= viewerState.minScale">
                                -
                            </button>
                            <span class="attachment-viewer--controls__scale-value">{{ viewerState.scale }}%</span>
                            <button class="attachment-viewer--control-button attachment-viewer--control-button--small"
                                @click="scaleUpIframe"
                                :disabled="viewerState.isBusy || viewerState.scale >= viewerState.maxScale">
                                +
                            </button>
                        </section>
                        <section class="attachment-viewer--controls__navigation">
                            <input id="attachment-viewer-scale-range" class="attachment-viewer--controls__range"
                                type="range" :value="viewerState.scale" @change="rangeChange"
                                :min="viewerState.minScale" :max="viewerState.maxScale"
                                :disabled="viewerState.isBusy" />
                        </section>
                    </section>
                    <section class="attachment-viewer--header--toolbar">
                        <ButtonOnlyWithIcon icon="download-black" v-tooltip.bottom="$t('com.global.download')"
                            @click="download" />
                        <ButtonOnlyWithIcon icon="save" v-tooltip.bottom="$t('com.file.attachment-viewer.save-scale')"
                            v-if="viewerState.isPdf && viewerState.isReady"
                            :class="{ 'active-icon-color': attachmentViewerSaveScale }"
                            @click="toggleAttachmentViewerSaveScale" />
                        <ButtonOnlyWithIcon v-if="isInteractive && isShow" icon="ukryj_wyniki_w_trakcie"
                            class="active-icon-color"
                            v-tooltip.bottom="$t('com.file.attachment-viewer.hide-on-ow')"
                            @click="toggleAttachmentViewerShowOnOW" />
                        <ButtonOnlyWithIcon v-if="isInteractive && !isShow" icon="ukryj_wyniki_w_trakcie"
                            v-tooltip.bottom="$t('com.file.attachment-viewer.show-on-ow')"
                            @click="toggleAttachmentViewerShowOnOW" />
                        <ButtonOnlyWithIcon icon="exit-btn" v-tooltip.bottom="$t('com.global.close')"
                            @click="closeModal" />
                    </section>
                </section>
                <section class="attachment-viewer--modal--body">
                    <button v-if="viewerState.isPdf && viewerState.isReady"
                        v-tooltip.right="$t('com.file.attachment-viewer.back-page')"
                        class="attachment-viewer--control-button attachment-viewer--modal-arrow attachment-viewer--modal-arrow--left"
                        @click="prevPageIframe" :disabled="viewerState.isBusy || viewerState.page <= 1">
                        <img src="@/assets/icons/panel/editSession/arrow-left.svg" />
                    </button>
                    <iframe :src="resolveIframeUrl()" style="border: none;" ref="modalIframe"
                        @load="bindIframeKeyboardEvents"></iframe>
                    <button v-if="viewerState.isPdf && viewerState.isReady"
                        v-tooltip.left="$t('com.file.attachment-viewer.next-page')"
                        class="attachment-viewer--control-button attachment-viewer--modal-arrow attachment-viewer--modal-arrow--right"
                        @click="nextPageIframe"
                        :disabled="viewerState.isBusy || viewerState.page >= viewerState.maxPages">
                        <img src="@/assets/icons/panel/editSession/arrow-left.svg" style="transform: rotate(180deg);" />
                    </button>
                </section>
                <section class="attachment-viewer--footer" v-if="viewerState.isPdf && viewerState.isReady"
                    ref="footerSection">
                    <span class="attachment-viewer--controls__page">
                        {{ $t('com.file.interactive-attachment-modal.page') }} {{ viewerState.page }}
                        {{ $t('com.file.attachment-viewer.of') }} {{ viewerState.maxPages }}
                    </span>
                </section>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
import esesjaInteractiveService from '../../../../../services/esesja.interactive.service';
import alertsHelper from '../../../../../helpers/alerts.helper';
import { fileDownloadHelperWithName } from "@/helpers/file.download.helper";
import ButtonOnlyWithIcon from "@/components/BasicControls/ButtonOnlyWithIcon.vue";
import settingsService from "@/services/settings.service";
export default {
    name: "AttachmentViewer",
    components: {
        ButtonOnlyWithIcon,
    },
    emits: ["close"],
    props: {
        title: {
            type: String,
            default: ''
        },
        pointId: {
            type: Number,
            required: true
        },
        attachmentId: {
            type: Number,
            required: true
        },
        fileData: {
            type: Object,
            require: true
        },
        filename: {
            type: String,
            require: true,
        },
        sessionId: {
            type: Number,
            require: true,
        }

    },
    watch: {
        '$refs.modalIframe': {
            deep: true,
            handler: function (e) {
                console.log("watch iframe", e)
            }
        },
        attachmentViewerSaveScale(value) {
            if (value === true && this.viewerState.isPdf && this.viewerState.scale > 0) {
                this.$store.commit("setAttachmentViewerCurrentScale", this.viewerState.scale);
            }
        }
    },
    data() {
        return {
            fileBlob: undefined,
            imageData: undefined,
            textData: undefined,
            fileType: {
                isPfd: false,
                isImage: false,
                isText: false,
            },
            pdfFIle: this.attachmentId,
            isBusy: false,
            viewerState: {
                isPdf: false,
                isReady: false,
                scale: 100,
                page: 1,
                maxPages: 1,
                minScale: 100,
                maxScale: 250,
                isBusy: false,
            },
            didApplySavedScale: false,
            restoredScaleAwaitingBroadcast: null,
        }
    },

    computed: {
        isInteractive() {
            return this.$store.state.appStore.isInInteractiveMode;
        },
        attachmentViewerCurrentScale() {
            return this.$store.state.settings.runtime.attachmentViewerCurrentScale;
        },
        attachmentViewerSaveScale() {
            return this.$store.state.settings.runtime.attachmentViewerSaveScale;
        },
        isShow(){
            return this.$store.state.settings.runtime.attachmentViewerIsShowOnOW;
        }
    },
    async mounted() {
        if (this.pointId === -1) {
            return;
        }

        if (this.attachmentId === -1) {
            return;
        }

        this.didApplySavedScale = false;
        this.restoredScaleAwaitingBroadcast = null;
        window.addEventListener('message', this.receiveMessage, false);
        window.addEventListener('resize', this.handleWindowResize, false);

        this.$refs.modal.focus();
    },
    beforeUnmount() {
        window.removeEventListener("message", this.receiveMessage);
        window.removeEventListener("resize", this.handleWindowResize);
        this.unbindIframeKeyboardEvents();
    },
    methods: {
        bindIframeKeyboardEvents() {
            const iframeWindow = this.$refs.modalIframe?.contentWindow;

            if (iframeWindow === undefined || iframeWindow === null) {
                return;
            }

            this.unbindIframeKeyboardEvents();
            iframeWindow.addEventListener("keyup", this.keyPressed);
            this.syncViewportConstraints(true);
        },

        unbindIframeKeyboardEvents() {
            const iframeWindow = this.$refs.modalIframe?.contentWindow;

            if (iframeWindow === undefined || iframeWindow === null) {
                return;
            }

            iframeWindow.removeEventListener("keyup", this.keyPressed);
        },

        receiveMessage(event) {
            if (this.$refs.modalIframe !== undefined && this.$refs.modalIframe !== null && event.source !== this.$refs.modalIframe.contentWindow) {
                return;
            }

            if (event.data?.attachmentViewerState !== undefined) {
                const wasReady = this.viewerState.isReady;
                const savedScale = this.attachmentViewerCurrentScale;
                this.viewerState = {
                    ...this.viewerState,
                    ...event.data.attachmentViewerState,
                };

                if (this.viewerState.isPdf && this.viewerState.scale > 0 && (!this.attachmentViewerSaveScale || this.didApplySavedScale === true)) {
                    this.$store.commit("setAttachmentViewerCurrentScale", this.viewerState.scale);
                }

                if (this.viewerState.isPdf && this.viewerState.isReady) {
                    if (this.attachmentViewerSaveScale && this.didApplySavedScale === false && savedScale > 0) {
                        this.didApplySavedScale = true;
                        this.restoredScaleAwaitingBroadcast = savedScale;
                        this.$nextTick(() => {
                            this.sendCommandToIframe("setScale", { scale: savedScale });

                            if (this.isInteractive) {
                                esesjaInteractiveService.changeAttachmentPage(this.sessionId, this.viewerState.page, savedScale);
                            }
                        });
                        return;
                    }

                    if (wasReady !== true) {
                        this.$nextTick(() => this.syncViewportConstraints(true));
                    }
                }
                return;
            }

            if (event.data.closeModal === true) {
                this.closeModal();
                return;
            }

            if (event.data.scroolView !== undefined && event.data.scroolView !== null && event.data.scroolView > -1) {
                this.scroolViewOw(event.data.scroolView);
                return;
            }

            if (event.data.width !== undefined && event.data.height !== undefined) {
                const availableSize = this.getAvailableContentSize();
                let maxWidth = availableSize.width;
                let maxHeight = availableSize.height;

                let isForce = false;
                if (event.data.force !== undefined) {
                    isForce = event.data.force;
                }
                let newHeight = 0;
                let newWidth = 0;
                if (isForce && this.viewerState.isPdf) {
                    newWidth = Math.min(event.data.width, maxWidth);
                    newHeight = Math.min(event.data.height, maxHeight);
                }
                else if (maxHeight >= event.data.height && maxWidth >= event.data.width) {
                    newHeight = event.data.height;
                    newWidth = event.data.width;
                }
                else {
                    let scaleX = maxWidth / event.data.width;
                    let scale = maxHeight / event.data.height;
                    if (scaleX < scale) {
                        scale = scaleX;
                    }
                    newHeight = event.data.height * scale;
                    newWidth = event.data.width * scale;
                }
                if (this.$refs.modalIframe !== null) {
                    this.$refs.modalIframe.style.width = `${newWidth}px`;
                    this.$refs.modalIframe.style.height = `${newHeight}px`;
                }

                if (isForce) {
                    if (this.restoredScaleAwaitingBroadcast !== null
                        && event.data.scale === this.restoredScaleAwaitingBroadcast) {
                        this.restoredScaleAwaitingBroadcast = null;
                    }

                    this.changeScale(event.data.page, event.data.scale);
                }

                if (event.data.nextPage !== undefined && event.data.nextPage === true) {
                    this.nextPage(event.data.page, event.data.scale);
                }

                if (event.data.prevPage !== undefined && event.data.prevPage === true) {
                    this.prevPage(event.data.page, event.data.scale);
                }
            }
        },
        resolveIframeUrl() {
            let routeResolve = this.$router.resolve({
                name: 'AttachmentViewer',
                params: { attachmentId: this.attachmentId },
                query: {
                    sessionId: this.sessionId,
                    isInteractive: this.isInteractive,
                    pointId: this.pointId
                }
            });
            return routeResolve.fullPath;
        },
        async closeModal() {
            window.removeEventListener("message", this.receiveMessage);
            this.unbindIframeKeyboardEvents();
            this.didApplySavedScale = false;
            this.restoredScaleAwaitingBroadcast = null;
            let urlCreator = window.URL || window.webkitURL;
            if (this.fileType.isPfd) {
                //this.fileBlob.destroy();
                urlCreator.revokeObjectURL(this.fileBlob);
                this.fileBlob = undefined;
            }
            else if (this.fileType.isImage) {
                urlCreator.revokeObjectURL(this.imageData)
            }
            this.fileType.isPfd = false;
            this.fileType.isImage = false;
            this.fileType.isText = false;

            this.$emit('close')
        },

        scroolViewOw(percent) {
            if (this.isInteractive) {
                esesjaInteractiveService.scroolAttachmentPage(this.sessionId, percent);
            }
        },

        prevPage(page, scale) {
            if (this.isInteractive) {
                esesjaInteractiveService.changeAttachmentPage(this.sessionId, page, scale);
            }
        },

        nextPage(page, scale) {
            if (this.isInteractive) {
                esesjaInteractiveService.changeAttachmentPage(this.sessionId, page, scale);
            }
        },

        changeScale(page, scale) {
            if (this.isInteractive) {
                esesjaInteractiveService.changeAttachmentPage(this.sessionId, page, scale);
            }
        },
        getAvailableContentSize() {
            const chromeHeight = this.getModalChromeHeight();
            let width = (window.document.documentElement.clientWidth * 0.9) - 96;
            let height = (window.document.documentElement.clientHeight * 0.9) - chromeHeight;

            if (width < 120) {
                width = 120;
            }

            if (height < 120) {
                height = 120;
            }

            return { width, height };
        },
        getModalChromeHeight() {
            const headerHeight = this.$refs.headerSection?.offsetHeight ?? 0;
            const footerHeight = this.$refs.footerSection?.offsetHeight ?? 0;

            return headerHeight + footerHeight + 16;
        },
        handleWindowResize() {
            this.syncViewportConstraints(true);
        },
        syncViewportConstraints(refit = false) {
            const availableSize = this.getAvailableContentSize();

            this.sendCommandToIframe("setViewportConstraints", {
                width: availableSize.width,
                height: availableSize.height,
                refit,
            });
        },
        sendCommandToIframe(command, data = {}) {
            if (this.$refs.modalIframe?.contentWindow === undefined) {
                return;
            }

            this.$refs.modalIframe.contentWindow.postMessage({
                attachmentViewerCommand: command,
                ...data,
            }, "*");
        },

        scaleUpIframe() {
            this.saveCurrentScale(this.viewerState.scale + 10);
            this.sendCommandToIframe("scaleUp");
        },

        scaleDownIframe() {
            this.saveCurrentScale(this.viewerState.scale - 10);
            this.sendCommandToIframe("scaleDown");
        },

        prevPageIframe() {
            this.sendCommandToIframe("prevPage");
        },

        nextPageIframe() {
            this.sendCommandToIframe("nextPage");
        },

        rangeChange(event) {
            event.preventDefault();
            event.target.blur();
            const scale = parseInt(event.target.value);
            this.saveCurrentScale(scale);
            this.sendCommandToIframe("setScale", { scale });
        },
        async toggleAttachmentViewerSaveScale() {
            const newValue = !this.attachmentViewerSaveScale;

            this.$store.commit("setAttachmentViewerSaveScale", newValue);

            if (newValue && this.viewerState.isPdf && this.viewerState.scale > 0) {
                this.$store.commit("setAttachmentViewerCurrentScale", this.viewerState.scale);
            }

            await this.updateAttachmentViewerSaveScale();
        },
        async updateAttachmentViewerSaveScale() {
            let data = { ...this.$store.state.settings.runtime };
            data.attachmentViewerSaveScale = this.$store.state.settings.runtime.attachmentViewerSaveScale;
            data.attachmentViewerCurrentScale = this.$store.state.settings.runtime.attachmentViewerCurrentScale;

            await settingsService.updateClientSettings(data);
        },
        async toggleAttachmentViewerShowOnOW() {
            const newValue = !this.isShow;

            let data = { ...this.$store.state.settings.runtime };
            data.attachmentViewerIsShowOnOW = newValue;

            await settingsService.updateClientSettings(data);

            if (this.isInteractive) {
                if (newValue) {
                    await this.showAttachments();
                }
                else {
                    await this.hideAttachments();
                }
            }
        },
        saveCurrentScale(scale) {
            const parsedScale = parseInt(scale);

            if (Number.isNaN(parsedScale)) {
                return;
            }

            const minScale = this.viewerState.minScale > 0 ? this.viewerState.minScale : 10;
            const maxScale = this.viewerState.maxScale > 0 ? this.viewerState.maxScale : 250;
            const normalizedScale = Math.min(Math.max(parsedScale, minScale), maxScale);

            this.$store.commit("setAttachmentViewerCurrentScale", normalizedScale);

            if (this.attachmentViewerSaveScale) {
                this.updateAttachmentViewerSaveScale();
            }
        },

        async hideAttachments() {
            await esesjaInteractiveService.closeAttachment(this.sessionId);
        },

        async showAttachments() {
            await esesjaInteractiveService.openAttachmentWithPage(this.sessionId, this.pointId, this.attachmentId, this.viewerState.page, this.viewerState.scale);

        },

        async download() {
            try {
                fileDownloadHelperWithName(this.fileData, this.filename);
            }
            catch {
                var errorAlert = this.$swal.mixin(alertsHelper.errorToastElement());
                errorAlert.fire(alertsHelper.errorToastAlert(this.$t('com.validation-error.download-file-error'), this.$t('com.global.error')));
            }
        },

        keyPressed(e) {
            if (!e.isTrusted) {
                return;
            }
            if (e.keyCode === undefined) {
                return;
            }
            if (this.viewerState.isBusy === true) {
                return;
            }

            switch (e.keyCode) {
                case 38:
                    if (this.viewerState.isPdf && this.viewerState.scale > this.viewerState.minScale) {
                        e.preventDefault();
                        this.sendCommandToIframe("scrollBy", { delta: -80 });
                    }
                    break;
                case 40:
                    if (this.viewerState.isPdf && this.viewerState.scale > this.viewerState.minScale) {
                        e.preventDefault();
                        this.sendCommandToIframe("scrollBy", { delta: 80 });
                    }
                    break;
                case 37:
                    if (this.viewerState.isPdf && this.viewerState.scale <= this.viewerState.minScale) {
                        e.preventDefault();
                        this.prevPageIframe();
                    }
                    break;
                case 39:
                    if (this.viewerState.isPdf && this.viewerState.scale <= this.viewerState.minScale) {
                        e.preventDefault();
                        this.nextPageIframe();
                    }
                    break;
                case 36:
                    if (this.viewerState.isPdf) {
                        e.preventDefault();
                        this.sendCommandToIframe("setPage", { page: 1 });
                    }
                    break;
                case 27:
                    e.preventDefault();
                    this.closeModal();
                    break;
            }
        },
    }
}
</script>
<style lang="scss" scope>
@use "../../../../../assets/scss/esesja-modal.scss";


.attachment-viewer-modal .esesja-modal__wraper {
    width: auto !important;
    height: auto !important;
    max-width: none !important;
    max-height: none !important;
    display: flex;
    justify-content: center;
    align-items: center;

    .active-icon-color {
        background-color: #d5f5d5;
    }
}

.attachment-viewer-modal .esesja-modal__wraper__body {
    width: auto !important;
    height: auto !important;
    max-width: none !important;
    max-height: 90vh !important;
    padding: 0px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.attachment-viewer--header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 16px;
    padding: 12px 16px 0;
    border-bottom: 1px solid #ccc;

    &--toolbar {
        grid-column: 3;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: nowrap;
        justify-self: end;

        :deep(.button-only-icon) {
            margin-right: 0;
            border-radius: 0;
        }

        :deep(.button-only-icon + .button-only-icon) {
            margin-left: -1px;
        }

        :deep(.button-only-icon:first-child) {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }

        :deep(.button-only-icon:last-child) {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
}

.attachment-viewer--controls {
    grid-column: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
    padding: 12px 16px 0;
    justify-self: center;

    &__scale,
    &__navigation {
        display: flex;
        align-items: center;
    }

    &__scale {
        gap: 8px;
    }

    &__scale-value,
    &__page {
        color: #1f2430;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }

    &__navigation {
        gap: 12px;
    }

    &__range {
        width: 350px;
        max-width: 45vw;
    }
}

.attachment-viewer--footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px 12px;
}

.attachment-viewer--modal--body {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 0;
    overflow: hidden;
    padding: 0 48px;

    iframe {
        display: block;
        max-height: 100%;
    }
}

.attachment-viewer--modal-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    &--left {
        left: 8px;
    }

    &--right {
        right: 8px;
    }
}

.attachment-viewer--control-button {
    width: 32px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #bbc2ce;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;

    &:hover:not([disabled]) {
        background-color: #e8ebef;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &--small {
        font-size: 18px;
        line-height: 1;
    }
}
</style>
